<template>
  <oie-my-pages-template :title="t('articleWatchTitle')" :text="t('articleWatchSubTitle')">
    <div class="my-article-watches__head">
      <div></div>
      <div> {{ tStatic('articleNumberLabel') }} </div>
      <div> {{ t('addedLabel') }} </div>
      <div> {{ t('pricePerArticle') }} </div>
      <div> {{ t('statusLabel') }} </div>
    </div>
    <div v-if="articleWatches.length > 0" class="my-article-watches__list">
      <oie-article-watch-item
        v-for="articleWatch in articleWatches"
        :key="articleWatch.id"
        :article-watch="articleWatch"
        @onModalHide="getArticleWatchByUser"></oie-article-watch-item>
    </div>
  </oie-my-pages-template>
</template>

<script>
import priceService from '@/core/price-service'
import httpService from '@/core/http-service'
import _ from 'lodash'

export default {
  data: () => ({
    articleWatches: []
  }),
  mounted() {
    this.getArticleWatchByUser()
  },
  methods: {
    getArticleWatchByUser() {
      httpService.get('article-watch/user').then(res => {
        if (res.data.items.length === 0) {
          this.articleWatches = []
          return
        }

        const articleWatches = res.data.items.map(articleWatch => {
          const { id, articleNumber, createdAt } = articleWatch
          return { id, articleNumber, createdAt }
        })

        this.getProducts(articleWatches)
      })
    },
    getProducts(articleWatches) {
      const ids = articleWatches.map(a => {
        return a.articleNumber
      })

      httpService.post('products', { productIds: ids, page: 1, pageSize: 1 }).then(res => {
        this.getProductListPrices(res.data.data, articleWatches)
      }, () => { this.notValid = true })
    },
    getProductListPrices(productData, articleWatches) {
      const ids = productData.map(p => {
        return p.id
      })
      httpService.post('productListPrices', { productId: ids }).then(res => {
        let products = productData
        priceService.populatePricesFromBackend(res.data, products)
        const newArticleWatches = articleWatches

        _.forEach(products, p => {
          const product = p
          const items = p.items
          _.forEach(items, item => {
            const index = _.findIndex(newArticleWatches, a => a.articleNumber === item.id)
            if (index !== -1) {
              product.items = [item]
              newArticleWatches[index].product = product
              return false
            }
          })
        })

        this.articleWatches = newArticleWatches
      })
    }
  }
}
</script>

<style lang="scss">
.my-article-watches__head {
  display: none;
  background-color: color(background-blue-6);
  padding: 1.125rem 1.5rem 0.75rem 1.5rem;
  border: 1px solid color(gray-4);
  @include body-smaller-semi-bold;
  color: color(gray-2);
  margin-bottom: 0.5rem;
}

.my-article-watches__list {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.5rem;
}

@include media(x-small) {
  .my-article-watches__list {
    grid-template-columns: repeat(2, 1fr);
  }
}

@include media(medium) {
  .article-watch-list {
    > h1 {
      @include h1-semi-bold;
    }
  }
  .my-article-watches__head {
    display: flex;

    > * {
      padding: 0 0.5rem;
    }

    > :first-child {
      width: 15%;
    }

    > :nth-child(2) {
      width: 30%;
    }

    > :nth-child(3) {
      width: 10%;
    }

    > :nth-child(4) {
      width: 15%;
    }

    > :nth-child(5) {
      width: 10%;
    }

    > :nth-child(6) {
      width: 10%;
      display: flex;
      justify-content: center;
    }

    > :nth-child(7) {
      width: 8%;
      display: flex;
      justify-content: center;
    }
  }

  .my-article-watches__list {
    grid-template-columns: 1fr;
  }
}
</style>
